"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mediaStorageTabs = void 0;
exports.mediaStorageTabs = {
    all: {
        text: "All",
        value: "all",
    },
    stepResources: {
        text: "Step resources",
        value: "step resources",
    },
    stepProof: {
        text: "Step proof",
        value: "step proof",
    },
};
